import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailQuestion, Library, Send } from "lucide-react";
import { api } from "../api";
import { toast } from "sonner";

export function Footer() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) { toast.error("Podaj poprawny adres email"); return; }
    setSending(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Zapisano do newslettera! Sprawdź skrzynkę.");
      setEmail("");
    } catch {
      toast.error("Nie udało się zapisać. Spróbuj ponownie.");
    } finally {
      setSending(false);
    }
  };

  return (
    <footer className="relative border-t border-cyan-500/10 bg-slate-950/85 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-12 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600">
                <Library className="h-5 w-5 text-white" />
              </div>
              <span className="font-display text-xl font-extrabold"><span className="gradient-text">DigiLib</span><span className="text-slate-400">.store</span></span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Twoja cyfrowa biblioteka. Ebooki i audiobooki z natychmiastową dostawą — czytaj i słuchaj, gdzie chcesz.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["Visa", "Mastercard", "Maestro", "BLIK", "Przelew"].map((p) => (
                <span key={p} className="rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-[10px] font-semibold text-slate-300">{p}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-slate-200">Sklep</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li><Link to="/" className="transition-colors hover:text-cyan-300">Strona główna</Link></li>
              <li><Link to="/blog" className="transition-colors hover:text-cyan-300">Blog</Link></li>
              <li><a href="/#bestsellery" className="transition-colors hover:text-cyan-300">Bestsellery</a></li>
              <li><a href="/#audiobooki" className="transition-colors hover:text-cyan-300">Audiobooki</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-slate-200">Informacje</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li>
                <button
                  data-testid="footer-book-request"
                  onClick={() => window.dispatchEvent(new Event("open-book-request"))}
                  className="flex items-center gap-1.5 font-bold gradient-text transition-opacity hover:opacity-75"
                >
                  <MailQuestion className="h-4 w-4 text-fuchsia-400" /> Nie znalazłeś książki?
                </button>
              </li>
              <li><Link to="/regulamin" className="transition-colors hover:text-cyan-300">Regulamin</Link></li>
              <li><Link to="/polityka-prywatnosci" className="transition-colors hover:text-cyan-300">Polityka prywatności</Link></li>
              <li><Link to="/wysylka" className="transition-colors hover:text-cyan-300">Wysyłka i dostawa</Link></li>
              <li><Link to="/platnosci" className="transition-colors hover:text-cyan-300">Sposoby płatności</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-slate-200">Newsletter</h4>
            <p className="mt-4 text-sm text-slate-400">Promocje i nowości — raz w tygodniu, zero spamu.</p>
            <form onSubmit={subscribe} className="mt-4 flex gap-2" data-testid="newsletter-form">
              <input
                data-testid="newsletter-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Twój adres email"
                className="w-full rounded-xl border border-slate-700 bg-slate-900/80 px-4 py-2.5 text-sm text-slate-200 placeholder-slate-500 outline-none transition-colors focus:border-cyan-500"
              />
              <button
                data-testid="newsletter-submit-button"
                disabled={sending}
                className="rounded-xl bg-gradient-to-r from-cyan-500 to-teal-500 p-2.5 text-slate-950 transition-transform hover:scale-105 active:scale-95 disabled:opacity-50"
                aria-label="Zapisz się"
              >
                <Send className="h-5 w-5" />
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-8 text-xs text-slate-500 sm:flex-row">
          <span>© 2026 DigiLib.store — Wszystkie prawa zastrzeżone.</span>
          <span>Sp. z o.o. · NIP: __________ · KRS: __________</span>
        </div>
      </div>
    </footer>
  );
}
